module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-09.38eaa703.jpg";